import React from 'react';
const phrases = ['Cabinet pulls & knobs', 'Wi-Fi locks', 'Barn doors', 'Floating shelves', 'TV mounting', 'Drapery & window dressing', 'Bath accessories', 'Soft-close upgrades', 'Gallery walls', 'House numbers'];
export function Marquee() {
  const line = [...phrases, ...phrases];
  return <div className="overflow-hidden border-y border-brass-dark/40 bg-brass py-4" data-id="element-122" data-mp="2dlm11nx8rihi">
      <div className="marquee-track flex w-max gap-10 whitespace-nowrap" aria-hidden="true" data-id="element-123" data-mp="3b8l2ebyvpelq">
        {line.map((phrase, index) => <span key={`${phrase}-${index}`} className="flex items-center gap-10 font-mono text-[11px] uppercase tracking-[0.24em] text-ink" data-id="element-124" data-mp="369rmkcw4dbie" data-mpi={index}>
            {phrase}
            <span className="h-1 w-1 rounded-full bg-ink/50" data-id="element-125" data-mp="2x80h995hr6p2" />
          </span>)}
      </div>
      <span className="sr-only" data-id="element-126" data-mp="1pwjkyki99xp4">
        Services include cabinet hardware, locks, doors, shelving, mounting, and drapery
        installation.
      </span>
    </div>;
}